export default theme => ({
  dashboardactionmenu__icon: {
    right: theme.spacing(2),
    marginLeft: 20,
    float: "right",
  },
});
